<template>
	<div>
		<Modal v-model="show" :width="1300" :footer-hide="true" title="意向单明细" :scrollable="true">
			<Spin v-if="innerSpin" size="large" fix></Spin>
			<Card :padding="0" :bordered="false" :dis-hover="true">

				<Row :gutter="16">
					<Col span="24">
					<Form label-position="top" class="form-input-no-outline">
						<Row :gutter="16">
							<Col span="4">
							<FormItem label="订单号">
								<Input :value="orderRecord.intentionBillRecordCode" readonly></Input>
							</FormItem>
							</Col>
							<Col span="4">
							<FormItem label="苗场">
								<Input :value="orderRecord.seedFarmName" readonly></Input>
							</FormItem>
							</Col>
							<Col span="4">
							<FormItem label="定单时间">
								<Input :value="formatDateTimeString(orderRecord.intentionBillRecordCreateAt)"
									readonly></Input>
							</FormItem>
							</Col>
							<Col span="2">
							<FormItem label="周期">
								<Input :value="orderRecord.weekSeq" readonly></Input>
							</FormItem>
							</Col>
							<Col span="4">
							<FormItem label="发货时间">
								<Input v-model="sendDeliveryDate"
									:value="formatDateString(orderRecord.intentionBillRecordSendProductDate)"></Input>
							</FormItem>
							</Col>
							<Col span="2">
							<FormItem label="定单总额(元)">
								<Input :value="orderRecord.totalMoney" readonly></Input>
							</FormItem>
							</Col>
						</Row>
						<Row :gutter="24">
							<Col span="4">
							<FormItem label="关联销售单号">
								<Input :value="orderRecord.intentionBillRecordRelatepreSaleOrderRecordCode"
									readonly></Input>
							</FormItem>
							</Col>
							<Col span="10">
							<FormItem label="客户地址">
								<Input :value="orderRecord.receiptFullAddress" readonly></Input>
							</FormItem>
							</Col>
							<Col span="6">
							<FormItem label="客户经理">
								<Input :value="orderRecord.customerName" readonly></Input>
							</FormItem>
							</Col>
						</Row>
						<Row :gutter="24">
							<Col span="8">
							<FormItem label="客户备注" v-if="$checkAccessArray(['S','B'])">
								<Input :value="orderRecord.customerMsg" readonly type="textarea"></Input>
							</FormItem>
							</Col>
							<Col span="6">
							<FormItem label="佣金比例">
								<Input :value="orderRecord.intentionBillDetailsalesAssociateCommissionPercent"
									readonly></Input>
							</FormItem>
							</Col>
						</Row>
						<Row :gutter="24">
							<Col span="24">
							<Row style="margin-bottom:5px ;" :gutter="30">
								<Col span="12">意向单明细</Col>
								<Col span="12" style="text-align: right;">
								<Button style="margin-right: 10px;" @click="updateCustomer"
									v-if="$checkAccessArray(['B', 'C'])" type="success">修改客户经理</Button>
								<Button 	:disabled="planProductsNoInDetail.length<1"  v-if="$checkAccessArray(['B', 'C','G'])" style="margin-right: 10px; "
								  @click="InserDetailInfo"	type="primary">新增产品</Button>
								<Poptip style="margin-right: 10px;" v-if="$checkAccessArray(['B', 'C',  'G'])"
									confirm placement="left" title="请确认信息是否无误？" @on-ok="saveDetailInfo"
									@on-cancel="cancel">
									<Button type="info">批量保存</Button>
								</Poptip>
								</Col>
							</Row>
							<FormItem>
								<Table ref="mainTable" size="small" :columns="orderDetail.columns"
									:data="orderDetail.rows" stripe border >
									<template slot-scope="{ row, index }" slot="intentionBillDetailProductName" ref="row">
										<Select v-model="row.productUuid" placeholder="选择品名" filterable
											@on-change="onProductSelectChange($event,row)" style="text-align: left;" 
											v-if="row.intentionBillDetailUuid == 'insert' && !row.intentionBillDetailProductCode">
											<Option v-for="item in planProductsNoInDetail" :key="item.productName"
												:value="item.productName">{{ item.productName
												}}</Option>
										</Select>
										<div v-else-if="row.intentionBillDetailProductPrice=='定金'" >{{ getDepositRate}}</div>
										<div v-else >{{ row.intentionBillDetailProductName}}</div>
									</template>
								</Table>
							</FormItem>
							</Col>
						</Row>
					</Form>

					</Col>
				</Row>
				<div style="text-align:right;">
					<Button type="info" style="margin-right: 20px;" @click="sumbitIntentionGetOrder">审核</Button>
					<Button type="error" @click="show=false">关闭</Button>
				</div>
				<Modal v-model="approveModel.show" title="审核意向单" class-name="vertical-center-modal" width="800">
					<Spin v-if="innerSpin" size="large" fix></Spin>
					<Form label-position="top">
						<Row :gutter="16">
							<Col span="6">
							<FormItem label="审核状态:" prop="approveStatus">
								<RadioGroup v-model="approveModel.approveStatus" type="button">
									<Radio :key="1" :label="1">审核通过</Radio>
									<Radio :key="2" :label="2">审核不通过</Radio>
								</RadioGroup>
							</FormItem>
							</Col>
							<Col span="24">
							<div><span style="color: red;">*</span>审核备注:</div>
							<FormItem label="" prop="approveRemark">
								<Input v-model="approveModel.approveRemark" type="textarea" :row="5"></Input>
							</FormItem>
							</Col>
						</Row>
					</Form>
					<div slot="footer">
						<Button type="primary" @click="onSaveApprove">确认</Button>
						<Button type="error" @click="approveModel.show=false">取消</Button>
					</div>
				</Modal>
				<Modal v-model="customerModel.show" title="修改客户经理" class-name="vertical-center-modal" width="800">
					<Spin v-if="innerSpin" size="large" fix></Spin>
					<Form label-position="top">
						<Row :gutter="16">
							<Col span="12">
							<FormItem label="选择客户经理:">
								<Select v-model="customerModel.customerId" filterable clearable
									@on-change="updateSelectCustomer" style="width:200px">
									<Option v-for="item in customerList" :value="item.userCustomerManagerLoginUuid"
										:key="item.userCustomerManagerLoginUuid">{{ item.userCustomerManagerName
										}}</Option>
								</Select>
							</FormItem>
							</Col>

						</Row>
					</Form>
					<div slot="footer">
						<Button type="primary" @click="onSaveCustomer">确认</Button>
						<Button type="error" @click="customerModel.show=false">取消</Button>
					</div>
				</Modal>
			</Card>
		</Modal>
		<!-- <AbandonedDepositDetail ref="abandonedDepositDetailModal" /> -->
	</div>
</template>

<script>
import { formatDateString, formatDateTimeString } from '@/libs/logic';
import CurrencyInput from '@/components/number-input/currency-input';
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
import { generateGuid } from '@/libs/tools';
import AbandonedDepositDetail from '@/view/sale-management/abandoned/abandoned-deposit-detail';
import {
    dateRender,
    dateTimeRender
} from '@/libs/tableRowTimeRender';

import {
    webIntentionGetOrderDetail,
    intentionRecordSubmitDeposit,
    deleteIntentionBillDetailByUuid,
    updateIntention,
    getProductPromotionList,
    getManagerList,
    updateIntentionCustomer,
    GetPreSalePlanWeeksSeedFarmAndDate
} from '@/api/modules/preSale-management/deposit-order';
import { 	getCustomerPromotionList } from '@/api/modules/sale-management/sale-approve';
import {
    ORDER_PAID_STATUS_TYPE_DEPOSIT_PAID
} from '@/view/preSale-management/preSale-order/PreSaleOrderStatus';
import {
    FILE_SERVER
} from '@/api/modules/files';
import { get } from 'sortablejs';
import { productQuantityIsRoundedMixin } from "@/view/mixins/ProductQuantityIsRounded.js";
export default {
    name: 'DepositOrderDetail',
    components: {
        AbandonedDepositDetail,
        CurrencyInput,
        DecimalInput,
        IntegerInput
    },
    mixins: [productQuantityIsRoundedMixin],
    data() {
        return {
            approveModel: {
                show: false,
                approveStatus: 1,
                approveRemark: ''
            },
            customerModel:{
                show: false,
                customerId:''
            },
            sendDeliveryDate:'',
            show: false,
            innerSpin: false,
            intentionBillRecordUuid: '',
            intentionBillUserUuid: '',
            intentionBillSeedFarmUuid: '',
            intentionBillRecordSendProductDate: '',
            orderRecord: {},
            pageLoading: false,
            productPromotionList:[],
            customerPromotionList:[],
            depoRa:0,
            deposit:0,
            customerList:[],
            planProducts:[],
            orderDetail: {
                columns: [
                    {
						    title: '序号',
                        align: 'center',
                        width:'50',
						    render:(h, params) =>{
                            if(!params.row.intentionBillDetailUuid){
									 h('span', '');
                            }
                            else{
                                return h('span', params.index+1);
                            }
						    }
                    },
                    {
                        title: "品种编号",
                        key: "intentionBillDetailProductCode"
                    },
                    {
                        title: "品种名称",
                        key: "intentionBillDetailProductName",
							  slot: "intentionBillDetailProductName"
                    },
                    {
                        title: "单位",
                        key: "intentionBillDetailProductUnit"
                    },
                    {
                        title: '数量',
                        align: 'center',
                        key: 'intentionBillDetailOrderQuantity',
							   render: (h, params) => {
								 if(params.row.intentionBillDetailUuid){
								   return h('InputNumber', {
                                    props: {
                                        value:parseFloat(params.row.intentionBillDetailOrderQuantity),
                                        min: 0,
                                        activeChange:false,
                                        step: params.row.productIncreaseStepAmount,
                                        precision:this.getUnitisRounded(params.row.intentionBillDetailProductUnit)
									 },
									 style:{
										 textAlign: "center"
									 },
									 on: {
                                        'on-change': (event) => {
                                            if(!event){
                                                event=0;
                                            }											
											 params.row.intentionBillDetailOrderQuantity = parseFloat(event);
											 this.updateRow(params.row, 'intentionBillDetailOrderQuantity');
                                        }
                                    }
                                });
							   }
							  else if(params.row.intentionBillDetailProductUnit=='合计'){
								  return h('span', parseFloat(this.totalQuantity.toFixed(2)));
							  }
							  else if(params.row.intentionBillDetailProductName=='包装费'||params.row.intentionBillDetailProductName=='配送费'){
								  return h('span', this.getPieces+'箱');
							  }
							  else{
								  return h('span', params.row.intentionBillDetailOrderQuantity);
							  }
                        }
                    },
                    {
                        title: '单价',
                        align: 'center',
                        key: 'intentionBillDetailProductPrice',
							   render: (h, params) => { 
								 if(params.row.intentionBillDetailUuid){
								   return h('InputNumber', {
                                    props: {
                                        value: params.row.intentionBillDetailProductPrice,
                                        min: 0,
                                        activeChange:false,
                                        formatter:value=>parseFloat(value.toString()),
                                        step: 0.01,
                                        precision:4
									 },
									 style:{
										 textAlign: "center"
									 },
									 on: {
                                        'on-change': (event) => {
											 params.row.intentionBillDetailProductPrice = event;
											 this.updateRow(params.row, 'intentionBillDetailProductPrice');
                                        }
                                    }
                                });
							   }
							   else if(params.row.intentionBillDetailProductName=='包装费'){
								  return h('span', this.getPackingFeePrice);
							  }
							  else if(params.row.intentionBillDetailProductName=='配送费'){
								  return h('span', this.getDeliveryFeePrice);
							  }
							   else{
								  return h('span', params.row.intentionBillDetailProductPrice);
							   }
                        }
                    },
                    {
                        title: '金额',
                        key: 'intentionBillDetailTotalMoney',
                        render: (h, params) => { 
								 if(params.row.intentionBillDetailUuid){
                                return h('span', this.getRowMenoy(params.row));						
							   }
							   else if(params.row.intentionBillDetailProductUnit=='合计'){
								  return h('span', this.totalMoney);
							  }
							   else if(params.row.intentionBillDetailProductName=='折扣'){
								  return h('span', this.getDiscount);
							  }
							   else if(params.row.intentionBillDetailProductPrice=='定金'){
                                //  return h('span',this.getDeposit);
								  return h('InputNumber', {
                                    props: {
                                        value: this.deposit,
                                        min: this.getDeposit,
                                        activeChange:false,
                                        formatter:value=>parseFloat(value.toString()),
                                        step: 0.01,
                                        precision:2
									 },
									 style:{
										 textAlign: "center"
									 },
									 on: {
                                        'on-change': (event) => {
                                            this.deposit = event;
                                        }
                                    }
                                });
							  }
							   else if(params.row.intentionBillDetailProductName=='包装费'){
								  return h('span', this.getPackingFee);
							  }
							   else if(params.row.intentionBillDetailProductName=='配送费'){
								  return h('span', this.getDeliveryFee);
							  }
							   else if(params.row.intentionBillDetailProductPrice=='总额'){
								  return h('span', this.totalAllMoney);
							  }
							   else{
								  return h('span', params.row.intentionBillDetailTotalMoney);
							   }
                        }
                    },
                    {
						    title: '操作',
						    key: 'action',
						    align: 'center',
						    width: 60,
						    render: (h, params) => {
                            return h('div', [
									    h('Button', {
									        props: {
									            type: 'text',
									            size: 'small',
									            shape: 'circle'
									        },
                                    style:{
                                        visibility: this.isShowRevoke(params.row)? 'visible' : 'hidden',
                                        backgroundColor:params.row.intentionBillDetailUuid=='insert'?'#2D8CF0':'#ED4014',
                                        color:'#fff'
                                    },
                                    on: {
											    click: () => {
											        this.cancelProduct(params.row);
											    }
                                    }
									    }, '撤销')
                            ]);
								
						    }
                    }
				
                ],
                rows: []
            }
        };
    },
    computed: {
        //合计数量
        totalQuantity(){
            let list= this.orderDetail.rows.filter(x=>x.intentionBillDetailUuid);
            let totalQuantity = list.reduce((sum, item) => sum + item.intentionBillDetailOrderQuantity, 0);
            return totalQuantity;
        },
        //合计金额
        totalMoney(){
            let list= this.orderDetail.rows.filter(x=>x.intentionBillDetailUuid);
            let totalMenoy = list.reduce((sum, item) => sum + this.getRowMenoy(item), 0);
            return parseFloat(totalMenoy.toFixed(2));
        },
        //计算定金
        getDeposit() {
            let deposit =0;
            let list= this.orderDetail.rows.filter(x=>x.intentionBillDetailUuid);
            list.forEach(item=>{
                deposit+=item.productPreSaleDepositRatio*this.getRowMenoy(item)/ 100;
            });
            let result = Math.ceil(deposit * 100) / 100;	
            this.deposit = result>this.deposit?result:this.deposit;	
            return result;
        },
        //定金比例
        getDepositRate() {
            let result = Math.round(this.deposit/this.totalMoney * 100);		
            return result;
        },
        getDiscount() {
            let customerDiscount = 0;     //客户优惠
            let customerPro = this.customerPromotionList[0];
            if (customerPro && customerPro.customerPromotion != null) {

                let customerPromotion=customerPro.customerPromotion;
                if (customerPromotion.promotionQuantityDisount > 0) {
                    customerDiscount+= (1-customerPromotion.promotionQuantityDisount)*this.totalMoney;					
                }
                //单价优惠,单位元,减1分=0.01、5分=0.05
                if (customerPromotion.promotionValudeDiscount > 0) {
                    customerDiscount += customerPromotion.promotionValudeDiscount*this.totalQuantity;						
                }
                //总价优惠,单位元,减100=100、减500=500、减1000=1000
                if (customerPromotion.promotionDepositDiscount > 0) {
                    customerDiscount +=customerPromotion.promotionDepositDiscount;
                }
            }
				
                
            let proudcutDiscount = 0;     //产品优惠
            let list=this.orderDetail.rows.filter(x=>x.intentionBillDetailUuid);

            for (let i = 0; i < list.length; i++) { 
                let orderItem = list[i];
                let productPro = this.productPromotionList.find(item => item.productUuid == orderItem.intentionBillDetailProductUuid);                    
                let itemproudcutDiscount=0;    //每一项产品优惠

                if (productPro && productPro.productPromotion != null) {
                    //达到指定订购量，可优惠  orderQuantity
                    if (orderItem.intentionBillDetailOrderQuantity >= productPro.productPromotion.promotionQuantityThreshold) {
                        itemproudcutDiscount = productPro.productPromotion.promotionQuantityDisount*orderItem.intentionBillDetailOrderQuantity;
                    }
                    //达到指定订购额，可优惠
                    if (orderItem.intentionBillDetailOrderQuantity >= productPro.productPromotion.promotionValueThreshold) {
                        itemproudcutDiscount += productPro.productPromotion.promotionValudeDiscount*orderItem.intentionBillDetailOrderQuantity;
                    }
                    //达到指定付定金比例，可优惠
                    if (orderItem.intentionBillDetailProductDepositRatio >= productPro.productPromotion.promotionDepositThreshold) {
                        //定金优惠     
                        itemproudcutDiscount += productPro.productPromotion.promotionDepositDiscount*orderItem.intentionBillDetailOrderQuantity;
                    }
                }
				    proudcutDiscount+=itemproudcutDiscount;
            } 
			   
            return parseFloat((customerDiscount+proudcutDiscount).toFixed(2));
        },
        //总额
        totalAllMoney() {
            //let list= this.orderDetail.rows.filter(x=>x.intentionBillDetailUuid);
            let discount = this.getDiscount;  //折扣
            let packageFee = this.orderRecord.intentionBillRecordTotalPackageFee;    //包装费用
            let deliveryFee = this.orderRecord.intentionBillRecordTotalDeliveryFee;   //配送费用
            let totalAllMenoy = this.totalMoney - discount + this.getPackingFee + this.getDeliveryFee;
            return parseFloat(totalAllMenoy.toFixed(2));
        },
        planProductsNoInDetail(){
            let resultList=[...this.planProducts];		
            if(this.orderDetail&&this.orderDetail.rows){
                let codes= this.orderDetail.rows.filter(item => item.intentionBillDetailUuid).map(item=>item.intentionBillDetailProductCode);
					 resultList= resultList.filter(item=>!codes.includes(item.productCode));
            }
            return resultList;                 
        },
        //计算总箱数
        getPieces(){
            let list= this.orderDetail.rows.filter(x=>x.intentionBillDetailUuid);
            let pieces=0;
            list.forEach(item=>{
                if((item.productPackingFee>0||item.productDeliveryFee>0)&&item.productPackageQuantity>0){
                    pieces+=Math.ceil(item.intentionBillDetailOrderQuantity/item.productPackageQuantity);
                }
            }); 
            return pieces;
        },
        //计算包装费
        getPackingFee(){
            let list= this.orderDetail.rows.filter(x=>x.intentionBillDetailUuid);
            let packingFee=0;
            list.forEach(item=>{
                if(item.productPackingFee>0&&item.productPackageQuantity>0){
                    let piece=Math.ceil(item.intentionBillDetailOrderQuantity/item.productPackageQuantity);
                    packingFee+=item.productPackingFee*piece;
                }
            });		
            return packingFee;
        },
        //计算配送费
        getDeliveryFee(){
            let list= this.orderDetail.rows.filter(x=>x.intentionBillDetailUuid);
            let deliveryFee=0;
            list.forEach(item=>{
                if(item.productDeliveryFee>0&&item.productPackageQuantity>0){
                    let piece=Math.ceil(item.intentionBillDetailOrderQuantity/item.productPackageQuantity);
                    deliveryFee+=item.productDeliveryFee*piece;
                }
            });		
            return deliveryFee;
        },
        //计算包装费单价
        getPackingFeePrice(){				
            return this.getPieces>0?(this.getPackingFee/this.getPieces).toFixed(2):0;
        },
			 //计算包装费单价
        getDeliveryFeePrice(){				
            return this.getPieces>0?(this.getDeliveryFee/this.getPieces).toFixed(2):0;
        }
    },
    mounted() {
        // this.init();
    },
    methods: {
        updateRow(row, colName){
            this.orderDetail.rows.forEach(item =>{
                if(row.intentionBillDetailUuid==item.intentionBillDetailUuid){
                    item[colName]=row[colName];
                    //	item.preSalePlanPrice=row.preSalePlanPrice;
                }
            });
        },
        //计算行金额
        getRowMenoy(row){
            let money=row.intentionBillDetailProductPrice*row.intentionBillDetailOrderQuantity;
            return parseFloat(money.toFixed(2));
        },
        updatePreSalePlanPrice(){
            let preSalePlanPrice=this.orderDetail.rows[0].preSalePlanPrice;
            this.orderDetail.rows.forEach(item =>{
                if(item.productCode){
                    item.preSalePlanPrice=preSalePlanPrice;
                }
            });
        },
        onProductSelectChange(event, row) {
            row.intentionBillDetailProductName = event;
            //this.updateRow(params.row,'productCode');
            let detail = this.orderDetail.rows.find(item => item.Id && row.Id == item.Id);
            //	detail.productCode =event;
            this.$set(detail, 'intentionBillDetailProductName', event);
            let product = this.planProducts.find(item => item.productName == event);
            detail.intentionBillDetailProductCode = product.productCode;
            detail.intentionBillDetailProductPrice = product.preSalePlanPrice;
            detail.intentionBillDetailProductUnit = product.unitName;
            detail.productPackingFee = product.packingFee;
            detail.productDeliveryFee = product.deliveryFee;
            detail.productPackageQuantity = product.productPackageQuantity;
            detail.productPreSaleDepositRatio = product.productPreSaleDepositRatio;
        },
        saveDetailInfo(){
				  let data={
                depositValue:this.deposit,
                intentionBillRecordUuid:this.intentionBillRecordUuid,
                orderItmeList: this.orderDetail.rows.filter(x=>x.intentionBillDetailUuid)
            };
				  this.innerSpin = true;
				  updateIntention(data).then(res => {
					  this.innerSpin = false;
					  if (res.code === 0) {
						  this.innerSpin = true;
						  this.webIntentionGetOrderDetail();
						  this.$parent.getMainTableRecords();
						  this.$Message.success('修改的信息保存成功！');	 
					  }
				  });
        },
        cancel() {
            this.$Message.info('请再次确认信息');
        },
        cancelProduct(row){
            if(row.intentionBillDetailUuid=='insert'){
                let index= this.orderDetail.rows.findIndex(item =>item.Id&&row.Id==item.Id);
                this.orderDetail.rows.splice(index, 1); 
                return;
            }
            this.innerSpin = true;
            let data={
                intentionBillRecordUuid:this.intentionBillRecordUuid,
                intentionBillDetailUuid:row.intentionBillDetailUuid
            };
			    deleteIntentionBillDetailByUuid(data).then(res => { 
                this.innerSpin = false;
					  if (res.code === 0) {
						  this.innerSpin = true;
						  this.webIntentionGetOrderDetail();
						  this.$parent.getMainTableRecords();
						  this.$Message.success('删除成功！');	 
					  }
			  });
        },
        formatDateString,
        formatDateTimeString,
        // onShowChange(e) {
        //     if (e) {
        //         this.webIntentionGetOrderDetail();
        //     }
        // },
        isShowRevoke(row){
            if(!this.$checkAccessArray(['B', 'C', 'G'])){
                return false;
            }
            // if(row.orderStatus!='提交'){
            //    return false;
            // }
            if(!row.intentionBillDetailUuid){
                return false;
            }
			    if(row.intentionBillDetailUuid!='insert'){
                //原定金单中存在的产品
                let row= this.orderDetail.rows.filter(item => item.intentionBillDetailUuid && item.intentiontBillDetailUuid != 'insert');
			        if(row.length<2){
                    return false;
                }
            }
            return true;
        },
        showModal(intentionBill) { 
            if(intentionBill){
                this.intentionBillRecordUuid = intentionBill.intentionBillRecordUuid;
			     	this.intentionBillUserUuid = intentionBill.intentionBillRecordOwnerUuid;
                this.intentionBillSeedFarmUuid = intentionBill.seedFarmUuid;
                this.intentionBillRecordSendProductDate = intentionBill.intentionBillRecordSendProductDate;
            }
            this.show = true;
		        this.webIntentionGetOrderDetail();
            this.getProductPromotionList();
            this.getCustomerPromotionList();
            this.getManagerList();
            this.getProductPlan();
        },
        showAbandonedDepositDetailModal(oldOrderUuid) {
            this.show = false;
			    this.$refs.abandonedDepositDetailModal.showModal(oldOrderUuid);
        },
        webIntentionGetOrderDetail() {
            if (this.intentionBillRecordUuid) {
                this.innerSpin = true;
                webIntentionGetOrderDetail({ intentionBillRecordUuid:this.intentionBillRecordUuid }).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        if (res.data.intentionBill != null) {
                            this.orderRecord = res.data.intentionBill;
                             
                            this.orderDetail.rows = res.data.intentionBill.detailList;
                            this.orderRecord.intentionBillDetailsalesAssociateCommissionPercent = this.orderDetail.rows[0].intentionBillDetailsalesAssociateCommissionPercent;
                            this.orderRecord.customerName = this.orderDetail.rows[0].customerName;
                            this.orderRecord.customerId = this.orderDetail.rows[0].customerId;
                            this.sendDeliveryDate=formatDateString(res.data.intentionBill.intentionBillRecordSendProductDate);
                            this.handleOrderDetail(this.orderRecord, this.orderDetail.rows);
                        }
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        },
        getManagerList(){
            getManagerList().then(res=>{
                if(res.code==0){
                    this.customerList=res.data.managerList;
                }
            });
        },
        //获取产品优惠
        getProductPromotionList(){
            getProductPromotionList({ intentionUuid:this.intentionBillRecordUuid }).then(res=>{
                if (res.code === 0) {
                    this.productPromotionList=res.data;
                }
            });
        },				
        //获取客户优惠
        getCustomerPromotionList(){ 
		 let seedFarmUuids = [this.intentionBillSeedFarmUuid];
            getCustomerPromotionList({ userUuid:this.intentionBillUserUuid, seedFarmUuids }).then(res=>{
                if(res.code==0){
                    this.customerPromotionList=res.data;
                }
            });
        },
        sumbitIntentionGetOrder() {
            this.approveModel.show = true;
            this.approveModel.approveStatus= 1;
            this.approveModel.approveRemark= '';				
        },
        updateCustomer(){
            this.customerModel.show = true;
            this.customerModel.customerId = this.orderRecord.customerId;
        },
        InserDetailInfo(){		
            let newRow= {};
            newRow.intentionBillDetailUuid="insert";	

            newRow.intentionBillDetailOrderQuantity=0;
            newRow.intentionBillDetailProductPrice=0;
	
            let index=this.orderDetail.rows.filter(x=>x.intentionBillDetailUuid).length;
            this.orderDetail.rows.splice(index, 0, newRow); 	
            newRow.Id=generateGuid();	
			
        },
        //审核意向单
        onSaveApprove(){
				 if(this.approveModel.approveStatus==2&&!this.approveModel.approveRemark){
                this.$Message.info('审核不通过时,备注信息不能为空');
                return;
				 }
				 this.innerSpin = true;
				 let data={
                intentionBillRecordUuid: this.orderRecord.intentionBillRecordUuid,
                ...this.approveModel
				 };
            intentionRecordSubmitDeposit(data).then(res => {
                this.innerSpin = false;
                if (res.code == 0) {
                    this.approveModel.show=false;
                    this.$Message.info('意向单审核成功');
                    this.show=false;
                    this.$emit('getList-event');				
                }
                else{
                    this.$Message.error(res.message);
                }
            });  		
        },
        getProductPlan(){
            if(this.$checkAccessArray(['B', 'C', 'G'])){
                let data={
                    seedFarmUuid:this.intentionBillSeedFarmUuid,
                    sendProductDate:formatDateString(this.intentionBillRecordSendProductDate)
                };
                GetPreSalePlanWeeksSeedFarmAndDate(data).then(res=>{
                    if(res.code === 0){
                        this.planProducts=res.data;
                    }
                });
            }
        },
        updateSelectCustomer(value){
            this.customerModel.customerId=value; 
        },
        onSaveCustomer(){				
            let userClickedOK = confirm("确定要修改客户经理吗?");
            if (!userClickedOK) {
                return;
            }
            if(!this.customerModel.customerId){
                this.$Message.warning('客户经理不能为空!');
            }
            this.innerSpin = true;
            let data={
                intentionBillRecordUuid:this.intentionBillRecordUuid,
                customerUuid:this.customerModel.customerId
            };
            updateIntentionCustomer(data).then(res=>{
                this.innerSpin = false;
                if(res.code==0){
                    this.$Message.success('客户经理修改成功');
                    this.customerModel.show=false;
                    this.webIntentionGetOrderDetail();
                    this.$parent.getMainTableRecords();
                }
                else{
                    this.$Message.err(res.message);
                }
            });

        },
        handleOrderDetail(orderRecord, items){
            if(items.length>0){
                let totalQuantity=items.reduce((accumulator, current) => accumulator + current.intentionBillDetailOrderQuantity, 0);
                let totalMoney=items.reduce((accumulator, current) => accumulator + current.intentionBillDetailTotalMoney, 0);
                items.push({ intentionBillDetailProductUnit:'合计', intentionBillDetailOrderQuantity:totalQuantity, intentionBillDetailTotalMoney:totalMoney });
                let depositDue=orderRecord.intentionBillRecordDepositDue;    //已付定金
                this.deposit=depositDue;
                let discount=orderRecord.intentionBillRecordProductDiscount;  //折扣
                let packageFee=orderRecord.intentionBillRecordTotalPackageFee;    //包装费用
                let deliveryFee=orderRecord.intentionBillRecordTotalDeliveryFee;   //配送费用
                let pieces=orderRecord.intentionBillRecordTotalPieces;   //箱数
                let packageFeePre=0;              //包装费单价
                let deliveryFeePre=0;             //配送费单价
                if(pieces>0){
                    packageFeePre=(packageFee/pieces).toFixed(2);
                    deliveryFeePre=(deliveryFee/pieces).toFixed(2);
                }
                this.depoRa=(depositDue*100/totalMoney).toFixed(0);
                let allTotalMoney=parseFloat((totalMoney-discount+deliveryFee+packageFee).toFixed(2));
                items.push({ intentionBillDetailProductCode:'定金收取(%)', intentionBillDetailProductName:this.depoRa, intentionBillDetailProductPrice:'定金', intentionBillDetailTotalMoney:depositDue });
                items.push({ intentionBillDetailProductName:'折扣', intentionBillDetailTotalMoney:discount });
                items.push({ intentionBillDetailProductName:'包装费', intentionBillDetailOrderQuantity:pieces+'箱', intentionBillDetailProductPrice:packageFeePre, intentionBillDetailTotalMoney:packageFee });
                items.push({ intentionBillDetailProductName:'配送费', intentionBillDetailOrderQuantity:pieces+'箱', intentionBillDetailProductPrice:deliveryFeePre, intentionBillDetailTotalMoney:deliveryFee });
                items.push({ intentionBillDetailProductPrice:'总额', intentionBillDetailTotalMoney:allTotalMoney });
			  }
        },
        onSave() {

        }

    }
};
</script>

<style>
    .ivu-table-cell{
        text-align: center;
    }
    .ivu-table-small th{
        text-align: center;
       }
    .ivu-table th, .ivu-table td{text-align: center !important;}
    th.ivu-table-column-left, td.ivu-table-column-left{text-align: center !important;}
    th.ivu-table-column-right, td.ivu-table-column-right{text-align: center !important;}
</style>
